import type { AnchorHTMLAttributes } from 'react';
import Link, { type LinkProps } from 'next/link';
import {
  type ButtonSize,
  type ButtonVariant,
  getButtonClassName,
} from './Button';

type AnchorProps = Omit<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  keyof LinkProps | 'href'
>;

export interface ButtonLinkProps extends LinkProps, AnchorProps {
  variant?: ButtonVariant;
  size?: ButtonSize;
  className?: string;
}

export const ButtonLink = ({
  href,
  variant = 'default',
  size = 'md',
  className,
  children,
  ...props
}: ButtonLinkProps) => {
  return (
    <Link
      href={href}
      className={getButtonClassName({ variant, size, className })}
      // Mirrors Button: the variant is the design decision worth asserting on,
      // and reading it off a class list is guesswork once twMerge has run.
      data-variant={variant}
      {...props}
    >
      {children}
    </Link>
  );
};

export default ButtonLink;
